// Breadcrumb.tsx
import React from "react";
import { Link } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Breadcrumb = _ref => {
  let {
    items
  } = _ref;
  return /*#__PURE__*/_jsx("nav", {
    className: "flex flex-wrap items-center text-sm text-gray-400 font-bold",
    children: items.map((item, index) => /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Link, {
        to: item.path,
        className: `hover:text-violet-400 transition duration-150 ease-in-out ${index === items.length - 1 ? "text-gray-400" : ""}`,
        children: item.name
      }), index < items.length - 1 && /*#__PURE__*/_jsx("span", {
        className: "mx-2 text-gray-400",
        children: /*#__PURE__*/_jsx("svg", {
          className: "flex-shrink-0 mx-2 h-3 w-3 text-gray-400",
          viewBox: "0 0 20 20",
          fill: "currentColor",
          "aria-hidden": "true",
          children: /*#__PURE__*/_jsx("path", {
            d: "M5.293 1.293a1 1 0 011.414 0l8 8a1 1 0 010 1.414l-8 8a1 1 0 01-1.414-1.414L11.586 10 5.293 3.707a1 1 0 010-1.414z"
          })
        })
      })]
    }, index))
  });
};
export default Breadcrumb;